import { render, staticRenderFns } from "./OperateData.vue?vue&type=template&id=01f724e1&scoped=true"
import script from "./OperateData.vue?vue&type=script&lang=js"
export * from "./OperateData.vue?vue&type=script&lang=js"
import style0 from "./OperateData.vue?vue&type=style&index=0&id=01f724e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f724e1",
  null
  
)

export default component.exports